module.exports = __webpack_public_path__ + "img/glasses.8ef7a931.png";